import { render, staticRenderFns } from "./EditWheatTypeModal.vue?vue&type=template&id=45171b23&"
import script from "./EditWheatTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditWheatTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports